import React, { useState } from 'react';
import TopBar from '../../Components/TopBar';
import Page from '../../Components/Containers/Page';
import { useStats } from '../../Data/Website';
import Section from '../../Components/Containers/Section';
import { PageLoading } from '../../Components/Loading';
import Chart from '../../Components/Chart';
import { numFormat } from '../../Services/helpers';

const Stats = () => {
    const {stats} = useStats(true);

    return <>
        <TopBar left="/more" title="Website stats" />
        <Page>
            {stats ? <Inner {...{stats}} /> : <PageLoading />}
        </Page>
    </>
}

const Inner = ({stats}) => {
    return <>
        <TheNumbers {...{stats}} />
        <TheChart {...{stats}} />
    </>
}

const TheNumbers = ({stats}) => {
    const [show, setShow] = useState('Today');
    const [theStats, setTheStats] = useState(stats.today ?? 0);
    const monthName = new Date().toLocaleString('default', { month: 'long' });

    const changeShow = (val) => {
        setShow(val);
        setTheStats(stats[val === 'Today' ? 'today' : 'month']);
    }
    return <>
        <Section title="Page views" options={['Today', monthName]} optionsVal={show} optionsCallback={changeShow}>
            <div className="grid grid-cols-2 gap-4">
                <div className="bg-slate-50 rounded-lg p-4 border">
                    <p className="text-gray-600 font-bold text-sm mb-2">Unique visitors</p>
                    <div className="text-brand text-4xl text-center">
                        {numFormat(theStats.visitors)}
                    </div>
                </div>
                <div className="bg-slate-50 rounded-lg p-4 border">
                    <p className="text-gray-600 font-bold text-sm mb-2">Page views</p>
                    <div className="text-brand text-4xl text-center">
                        {numFormat(theStats.pageViews)}
                    </div>
                </div>
            </div>
        </Section>
    </>
}

const TheChart = ({stats}) => {
    if (!stats.recentPageViews) {
        return null;
    }

    const show = Object.values(stats.recentPageViews).reduce((total, v) => total += v);

    if (show < 5) {
        // return null;
    }

    const chartData = {
        labels: Object.keys(stats.recentPageViews),
        datasets: [
            {
                label: 'Page views',
                data: Object.values(stats.recentPageViews),
                backgroundColor: '#2965ad',

            },
        ]
    };

    const chartOptions = {
        plugins: {
            legend: {
                display: false
            },
        }
    }

    return <Section title="Recent page views" className="mt-5">
        <Chart type="Bar" options={chartOptions} data={chartData} />
    </Section>
}

export default Stats;
